import React from 'react';
import { useIntl } from 'react-intl';
var InfoMessage = function (props) {
    var messageType = props.messageType, messageCode = props.messageCode, messageText = props.messageText, isMessageShown = props.isMessageShown, classes = props.classes;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement("span", { className: classes.root }, isMessageShown ?
        (function () {
            switch (messageCode) {
                case 10001:
                    return formatMessage({ id: "infoMessage.error.NotUniqueEmail" });
                    break;
                case 10002:
                    return formatMessage({ id: "infoMessage.error.NotUniquePhone" });
                    break;
                case 10003:
                    return formatMessage({ id: "infoMessage.error.InvalidPhoneOrEmail" });
                    break;
                default:
                    return null;
            }
        })()
        : ''));
};
export default InfoMessage;



//////////////////
// WEBPACK FOOTER
// ./src/components/Messages/Messages.tsx
// module id = 812
// module chunks = 0